import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

interface DrawingButtonProps {
    onClick: () => void;
    mode: 'walking' | 'cycling' | 'driving';
    label?: string;
}

const MODE_ICON: Record<string, string> = {
    walking: '🚶',
    cycling: '🚴',
    driving: '🚗',
};

const DrawingButton: React.FC<DrawingButtonProps> = ({ onClick, mode, label }) => {
    useMap();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            L.DomEvent.disableClickPropagation(ref.current);
            L.DomEvent.disableScrollPropagation(ref.current);
        }
    }, []);

    return (
        <div
            ref={ref}
            style={{
                position: 'absolute',
                top: '206px',   /* 158px (ToolsButton) + 40px (height) + 8px (gap) */
                left: '20px',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                pointerEvents: 'auto',
            }}
            onClick={e => e.stopPropagation()}
        >
            <button
                onClick={onClick}
                title="Arrêter la création (clic droit sur un point pour le supprimer)"
                style={{
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    borderRadius: '6px',
                    background: '#f357a1',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
                    cursor: 'pointer',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {MODE_ICON[mode] ?? '✏️'}
            </button>
            <span style={{
                background: 'white',
                borderRadius: '4px',
                fontSize: '10px',
                textAlign: 'center',
                padding: '2px 4px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                color: '#555',
                whiteSpace: 'nowrap',
            }}>
                {label ?? 'Arrêter'}
            </span>
        </div>
    );
};

export default DrawingButton;
